
export default {
  methods: {
    toggleMenu() {
      this.$drawer.toggle('main')
    }
  }
}
